/**
 * Logout the authenticated user
 */
export const AUTH_LOGOUT = 'AUTH_LOGOUT';

/**
 * Toggle auth modal
 */
export const AUTH_MODAL = 'AUTH_MODAL';

/**
 * Request guest token
 */
export const AUTH_GUEST_TOKEN = 'AUTH_GUEST_TOKEN';

/**
 * Request customer token
 */
export const AUTH_CUSTOMER_TOKEN = 'AUTH_CUSTOMER_TOKEN';

export const AUTH_CHECK_PHONE = 'AUTH_CHECK_PHONE';

export const CHECK_CUSTOMER_PROFILE = 'CHECK_CUSTOMER_PROFILE';

export const AUTH_PROFILE = 'AUTH_PROFILE';

/**
 * Set user type depending on login (guest, customer)
 */
export const SET_USER_TYPE = 'SET_USER_TYPE';

/**
 * Reset password by email
 */
export const AUTH_FORGOT_PASSWORD = 'AUTH_FORGOT_PASSWORD';

/**
 * Reset password
 */
export const AUTH_RESET_PASSWORD = 'AUTH_RESET_PASSWORD';


/**
 * Auth pending.
 */
export const AUTH_PENDING = 'AUTH_PENDING';

/**
 * Request kiosk token
 */
export const AUTH_KIOSK_TOKEN = 'AUTH_KIOSK_TOKEN';

/**
 * Request auth guest data
 */
export const AUTH_GUEST_INFO = 'AUTH_GUEST_INFO';

/**
 * Change auth token in store
 */
export const AUTH_TOKEN = 'AUTH_TOKEN';

/**
 * Push device FCM token.
 * @type {string}
 */
export const PUSH_DEVICE_FCM_TOKEN = 'PUSH_DEVICE_FCM_TOKEN';

/**
 * Resend device FCM token.
 * @type {string}
 */
export const RESEND_DEVICE_FCM_TOKEN = 'RESEND_DEVICE_FCM_TOKEN';

/**
 * Will initiate the process of removing the account.
 */
export const ACCOUNT_REMOVAL_REQUESTED = 'ACCOUNT_REMOVAL_REQUESTED';

/**
 * The complete confirmation of the account removal with a secret token from the email.
 */
export const ACCOUNT_REMOVAL_CONFIRMED = 'ACCOUNT_REMOVAL_CONFIRMED';

export default {
  AUTH_LOGOUT,
  AUTH_MODAL,
  AUTH_GUEST_TOKEN,
  AUTH_CUSTOMER_TOKEN,
  AUTH_CHECK_PHONE,
  AUTH_PROFILE,
  SET_USER_TYPE,
  AUTH_PENDING,
  AUTH_FORGOT_PASSWORD,
  AUTH_RESET_PASSWORD,
  AUTH_KIOSK_TOKEN,
  AUTH_GUEST_INFO,
  AUTH_TOKEN,
  PUSH_DEVICE_FCM_TOKEN,
  RESEND_DEVICE_FCM_TOKEN,
  ACCOUNT_REMOVAL_REQUESTED,
  ACCOUNT_REMOVAL_CONFIRMED,
};



// WEBPACK FOOTER //
// ./src/apps/auth/store/types.js